// EventsPage.jsx
import React, { useState, useEffect, useCallback } from 'react'
import anearApi from '../Api/AnearApi'
import TokenStorage from '../Api/TokenStorage'
import UIStateContainer from '../Containers/UIStateContainer'
import EventList from '../UI/EventList'
import Box from '@mui/material/Box'
import useNavigation from '../Utils/navigationUtils'
import {
  contentColumnMaxWidthSx,
  contentColumnPageShellSx
} from '../UI/contentColumn'

const usePlayableEvents = (shouldFetch = true) => {
  const [events, setEvents]   = useState([])
  const [venues, setVenues]   = useState([])
  const [loading, setLoading] = useState(shouldFetch)

  const uiContainer = UIStateContainer.useContainer()
  const { startProgress, progressComplete } = uiContainer

  const fetchEvents = useCallback(async () => {
    const [playableEvents, playableVenues] = await Promise.all([
      anearApi.playableEvents({ radius: 4000 }, false),
      anearApi.playableVenues()
    ])
    setEvents(playableEvents)
    setVenues(playableVenues)
    return { playableEvents, playableVenues }
  }, [])

  const reloadEvents = useCallback(async () => {
    try {
      startProgress()
      return await fetchEvents()
    } finally {
      progressComplete()
    }
  }, [fetchEvents, progressComplete, startProgress])

  useEffect(() => {
    if (!shouldFetch) {
      setLoading(false)
      return
    }

    let cancelled = false

    const loadEvents = async () => {
      try {
        startProgress()
        await fetchEvents()
      } catch (err) {
        console.error(err)
      } finally {
        if (!cancelled) setLoading(false)
        progressComplete()
      }
    }

    loadEvents()
    return () => { cancelled = true }
  }, [shouldFetch]) // eslint-disable-line react-hooks/exhaustive-deps

  return { events, venues, loading, reloadEvents }
}

const EventsPage = () => {
  const tokenStorage = new TokenStorage()
  const { navigateToVenue } = useNavigation()
  const venueContext = tokenStorage.hasActiveVenueHomeContext() ? tokenStorage.getVenueHomeContext() : null
  const activeVenueSlug = venueContext?.venueSlug || null
  const { events, venues, loading, reloadEvents } = usePlayableEvents(!activeVenueSlug)

  useEffect(() => {
    if (!activeVenueSlug) return
    navigateToVenue(activeVenueSlug)
  }, [activeVenueSlug]) // eslint-disable-line react-hooks/exhaustive-deps

  if (activeVenueSlug) return null
  if (loading) return null

  return (
    <Box sx={contentColumnPageShellSx}>
      <Box sx={{ ...contentColumnMaxWidthSx, overflowX: 'hidden' }}>
        <EventList
          playableEvents={events}
          playableVenues={venues}
          onEventsChanged={reloadEvents}
        />
      </Box>
    </Box>
  )
}

export default EventsPage
